import { UploadOutlined } from "@ant-design/icons";
import { Upload, Button, message } from "antd";
import React, { useState, useEffect } from "react";
import { strings } from "res";

const DocumentUploader = ({ onChange, documentData }) => {
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    if (documentData.original_name) {
      setFileName(documentData.original_name);
    } else if (documentData.url) {
      const parts = documentData.url.split("/");
      setFileName(parts[parts.length - 1]);
    }
  }, [documentData]);

  const beforeUpload = (file) => {
    const isAllowedType =
      file.type === "application/pdf" || file.type === "application/msword";
    //   file.type ===
    //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    if (!isAllowedType) {
      message.error("You can only upload PDF documents!");
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error("Document must be smaller than 10MB!");
    }
    message.success("Document successfully uploaded!");
    return isAllowedType && isLt10M;
  };

  const handleChange = (info) => {
    if (info.file.status === "done") {
      setFileName(info.file.response.data.original_name);
      onChange(info);
    }
  };

  return (
    <div>
      <Upload
        name="file"
        showUploadList={false}
        action={strings.api.upload_api_document}
        onChange={handleChange}
        beforeUpload={beforeUpload}
      >
        <Button icon={<UploadOutlined />}>
          {documentData ? "Ganti Dokumen" : "Upload Dokumen"}
        </Button>
      </Upload>

      {fileName && (
        <p style={{ marginTop: 8 }}>
          Dokumen:{" "}
          {documentData.url ? (
            <a
              href={documentData.url} //
              target="_blank"
              rel="noopener noreferrer"
            >
              {fileName}
            </a>
          ) : (
            fileName
          )}
        </p>
      )}
    </div>
  );
};

export default DocumentUploader;
